import React from 'react';
import { connect } from 'react-redux';
import EducationLawyer from '../../../components/Forms/Perfil/EducationLawyer';
import { Formik } from 'formik';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import { editEducation } from '../../../store/actions/UserAction';
import {
  showLoading,
  hideLoading,
} from '../../../store/actions/LoadingActions';
import EducationFormContainer from './EducationFormContainer';

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

const EditEducation = (props) => {
  const {
    uid,
    evento,
    item,
    flagEdit,
    educationLawyer,
    setFlagEdit,
    alreadyRewarded,
    handleRewarded,
    handleTrophieModalOpen,
    handleSnack,
    showLoading,
    hideLoading,
    helper,
    helperTrue,
    helperFalse,
    getValues,
    editEducation
  } = props;

  const isObjectFull = (array) => {
    const allValues = Object.values(array.slice(-1).pop());
    const evaluation = allValues.every((elem) => {
      if (elem !== '') {
        return true;
      }
      return false;
    });
    return evaluation;
  };

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
    showLoading();

    let boolValues = isObjectFull(values.educationLawyer);

    const filtered = educationLawyer.filter((elem, index) => {
      return index !== item;
    });

    if (boolValues === false) {
      handleRewarded(false);
    }

    //console.log('submiting', values.educationLawyer, boolValues, uid);

    editEducation(uid, values.educationLawyer, filtered, boolValues).then(
      (res) => {
        if (alreadyRewarded === false) {
          handleTrophieModalOpen(boolValues);
        }
        hideLoading();
        //resetForm();
        hideLoading();
        setTimeout(() => {
          setFlagEdit(0);
          scroller.scrollTo('education_section', { smooth: true, offset: -64 });
          handleSnack();
        }, 2000);
      }
    );
  };

  const resetTab = () => {
    scroller.scrollTo('education_section', { smooth: true, offset: -64 });
    evento(false);
  };

  const formValues = {
    flagEdit: 1,
    item: uid,
    educationLawyer: educationLawyer ? [educationLawyer[item]] : '',
  };

  return (
      <div className="addAwards">
        <Formik
          initialValues={formValues}
          onSubmit={handleSubmit}
          render={props => {
              return (
                <EducationFormContainer
                    {...props}
                    evento={resetTab}
                    nElem={item}
                    helper={helper}
                    helperTrue={helperTrue}
                    helperFalse={helperFalse}
                    getValues={getValues}
                    edit={flagEdit}
                />
              )
          }}
        />
      </div>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  educationLawyer: state.authClient.educationLawyer,
});

const mapDispatchToProps = (dispatch) => ({
  editEducation: (uid, values, filtered, boolValues) =>
    dispatch(editEducation(uid, values, filtered, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEducation);
